export const PRESCHOOL = 'PRESCHOOL';
export const COMPULSORY_SCHOOL = 'COMPULSORY_SCHOOL';
export const UPPER_SECONDARY_EDUCATION = 'UPPER_SECONDARY_EDUCATION';
export const ADULT_EDUCATION = 'ADULT_EDUCATION';